import { createAction, props } from "@ngrx/store";
import { AuthUser } from "../../../../core/class/auth/auth-user";
import { AuthResult } from "../../../../core/class/auth/auth-result";
import { Collaborator } from "../../../user/model/collaborator";
export enum AuthActionTypes {
  LOGIN = "[Login Page] Login",
  LOGIN_SUCCESS = "[Login Page] Login Success",
  LOGIN_FAIL = "[Login Page] Login Fail",
  LOGOUT = "[Login Page] Logout",
}
export const login = createAction(
  AuthActionTypes.LOGIN,
  props<{ authUser: AuthUser }>()
);
export const loginSuccess = createAction(
  AuthActionTypes.LOGIN_SUCCESS,
  props<{ authResult: AuthResult }>()
);
export const loginFail = createAction(
  AuthActionTypes.LOGIN_FAIL,
  props<{ error: any }>()
);

export const logout = createAction(AuthActionTypes.LOGOUT, props);
